import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
const { Option } = Select;

/** Idiomas da reunião: os mesmos que o backoffice oferece ao marcar. */
export const MeetingLanguages = [
  { code: 'pt', name: 'LANG_PT' },
  { code: 'en', name: 'LANG_EN' }
];

const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  .label {
    margin-bottom: 4px;
  }
`;

/**
 * Escolha do tipo de atendimento e do idioma da reunião, feita pelos
 * noivos antes de marcar. O tipo é só "Presencial" ou "Online" (`_id` =
 * IN_PERSON / ONLINE); a API converte-o no tipo do espaço do casamento.
 * As opções podem vir já limitadas ao que um organizador atende (agenda
 * partilhada).
 */
const MeetingOptionsFields = ({
  attendingTypes,
  attendingType,
  language,
  languages = MeetingLanguages,
  disabled,
  onChangeAttendingType,
  onChangeLanguage,
  translate,
  activeLanguage
}) => (
  <React.Fragment>
    <Field>
      <span className="label">{translate('ATTENDING_TYPE')} *</span>
      <Select
        style={{ width: '100%' }}
        placeholder={translate('SELECT')}
        value={attendingType || undefined}
        disabled={disabled}
        onChange={value => onChangeAttendingType(value || null)}>
        {(attendingTypes || []).map(m => (
          <Option key={m._id} value={m._id}>
            {translate(`MEETING_TYPE_${m._id}`)}
          </Option>
        ))}
      </Select>
    </Field>
    <Field>
      <span className="label">{translate('MEETING_LANGUAGE')} *</span>
      <Select
        style={{ width: '100%' }}
        placeholder={translate('SELECT')}
        value={language || undefined}
        disabled={disabled}
        onChange={value => onChangeLanguage(value || null)}>
        {languages.map(m => (
          <Option key={m.code} value={m.code}>{translate(m.name)}</Option>
        ))}
      </Select>
    </Field>
  </React.Fragment>
);

export default MeetingOptionsFields;
